import configureStore from "redux/configurations/configureStore";

export const mobileRole = () => {
  return isSuperAdmin() || isAdmin() || isOperator();
};

export const isSuperAdmin = () => {
  return (
    configureStore()
      .store.getState()
      .IdentityReducer.authenticate?.roles.includes("SuperAdmin") || false
  );
};

export const isAdmin = () => {
  return (
    configureStore()
      .store.getState()
      .IdentityReducer.authenticate?.roles.includes("Admin") || false
  );
};
export const isPlanner = () => {
  return (
    configureStore()
      .store.getState()
      .IdentityReducer.authenticate?.roles.includes("Planner") || false
  );
};
export const isViewer = () => {
  return (
    configureStore()
      .store.getState()
      .IdentityReducer.authenticate?.roles.includes("View") || false
  );
};
export const isOperator = () => {
  return (
    configureStore()
      .store.getState()
      .IdentityReducer.authenticate?.roles.includes("Operator") || false
  );
};

export const isSupervisor = () => {
  return (
    configureStore()
      .store.getState()
      .IdentityReducer.authenticate?.roles.includes("Supervisor") || false
  );
};
